/* global axios */
import ApiClient from './ApiClient';

class ContactListsAPI extends ApiClient {
  constructor() {
    super('contact_lists', { accountScoped: true });
  }

  addContacts(listId, contactIds) {
    return axios.post(`${this.url}/${listId}/add_contacts`, {
      contact_ids: contactIds,
    });
  }

  addAllContacts(listId) {
    return axios.post(`${this.url}/${listId}/add_all_contacts`);
  }

  addInboxContacts(listId, inboxId) {
    return axios.post(`${this.url}/${listId}/add_inbox_contacts`, {
      inbox_id: inboxId,
    });
  }

  removeContacts(listId, contactIds) {
    return axios.delete(`${this.url}/${listId}/remove_contacts`, {
      data: { contact_ids: contactIds },
    });
  }

  removeDuplicates(listId) {
    return axios.post(`${this.url}/${listId}/remove_duplicates`);
  }

  mergeDuplicateContacts() {
    return axios.post(`${this.url}/merge_duplicate_contacts`);
  }

  removeByDdd(listId, ddd) {
    return axios.delete(`${this.url}/${listId}/remove_by_ddd`, {
      data: { ddd },
    });
  }

  getContacts(listId, page = 1) {
    return axios.get(`${this.url}/${listId}/contacts`, {
      params: { page },
    });
  }

  importContacts(listId, contacts) {
    return axios.post(`${this.url}/${listId}/import_contacts`, {
      contacts,
    });
  }

  exportContacts(listId) {
    return axios.get(`${this.url}/${listId}/export_contacts`, {
      responseType: 'blob',
    });
  }
}

export default new ContactListsAPI();
